import styled from 'styled-components';

const HorizontalScroll = styled.div`
  flex-wrap: nowrap;
  display: flex;
  overflow-x: auto;
  padding: 10px 0;
  
  ::-webkit-scrollbar{
    height: 7px;
    width: 4px;
    background: rgba(128,128,128,0.3);
  }
    
  ::-webkit-scrollbar-thumb:horizontal{
    background: gray;
    border-radius: 10px;
  }
`;

export default HorizontalScroll;
